import type { NormalizedTweetType } from './formatTwitterResponse';

type TweetType = 'reply' | 'retweet' | 'tweet';

function determineTweetType(tweet: NormalizedTweetType): TweetType {
  const isReply =
    !!tweet.in_reply_to_user_id ||
    tweet.referenced_tweets?.[0]?.type === 'replied_to';

  const isRetweet = tweet.retweet;

  if (isReply) {
    return 'reply';
  }

  if (isRetweet) {
    return 'retweet';
  }

  return 'tweet';
}

export type TweetTypesListing = {
  replies: boolean;
  retweets: boolean;
  tweets: boolean;
};

export const checkTypeOfTweet = (
  tweet: NormalizedTweetType,
  {
    replies: withReply,
    retweets: withRetweet,
    tweets: withTweet
  }: TweetTypesListing
) => {
  const tweetType = determineTweetType(tweet);

  const availableTweetTypes: TweetType[] = Object.entries({
    reply: withReply,
    retweet: withRetweet,
    tweet: withTweet
  })
    .map(([key, value]) => value && key)
    .filter(Boolean) as TweetType[];

  return availableTweetTypes.includes(tweetType);
};
